/* eslint-disable */
import React from 'react'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import jMoment from 'moment-jalaali'
import HeaderTable from '../BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import Page from '../Pagination/Pagination'
import cookie from 'react-cookies'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import $ from 'jquery'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'

class WareHouseList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      warehouses: [],
      modalDelete: false,
      modalEdit: false,
      errorname: '',
      errorType: '',
      errorActive: '',
      wareType: [],
      wareHousesname: [],
      wareTypeStatus: '',
      Drivers: [],
      printInfo: []
    }
  }

  changeWareType(e) {
    let value = e.target.value
    sessionStorage.setItem('typePrimary', value)

    this.setState({
      wareTypeStatus: value
    })
  }

  getAllWarehouse = (
    params = sessionStorage.getItem('params'),
    pageNumber = sessionStorage.getItem('pageNumber'),
    pageSize = sessionStorage.getItem('dropDownVal')
  ) => {
    http
      .get(
        `${
          WAREHOUSE.WAREHOUSE_REPORT_TYPE_WAREHOUSE
        }?export=false&pageSize=${pageSize}&pageNumber=${pageNumber}&${params}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          $('.tableVisibile').fadeIn()
          this.setState({
            warehouses: response.data.object.result,
            length: response.data.object.countAll
          })
        } else {
          $('.tableVisibile').fadeOut()
          this.setState({
            warehouses: [],
            length: response.data.object.countAll
          })
        }
        // alert(JSON.stringify(response))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  componentDidMount() {
    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          this.setState({
            Drivers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })

    http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_WAREHOUSE}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            wareHousesname: response.data.object
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')
    this.getAllWarehouse()

    http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_PRIMARYWAREHOUSE}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            wareType: response.data.object
          })
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  delete = (numRow) => {
    let warehouseId = this.state.warehouses[numRow].id
    let warehouseName = this.state.warehouses[numRow].name
    sessionStorage.setItem('id', warehouseId)
    sessionStorage.setItem('selectedRow', numRow)
    sessionStorage.setItem('warehouseName', warehouseName)
    this.setState({
      modalDelete: !this.state.modalDelete
    })
  }

  toggleCancel = () => {
    this.setState({
      modalDelete: !this.state.modalDelete
    })
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('warehouseName')
  }

  deleteCancel = () => {
    this.setState({
      modalDelete: !this.state.modalDelete
    })
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('warehouseName')
  }

  deleteOk = () => {
    var selectedRow = sessionStorage.getItem('selectedRow')

    let wareId = sessionStorage.getItem('id')
    let data = {
      id: wareId
    }
    http
      .post(`${WAREHOUSE.WAREHOUSE_TYPE_DELETE_WAREHOUSE}`, data, {})
      .then((response) => {
        if (response.data.error == null && response.data.object == 'SUCCESS') {
          message.success('انبار با موفقیت حذف شد')
          this.state.warehouses.splice(selectedRow, 1)
          this.setState(this.state.warehouses)
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        } else {
          message.error(JSON.stringify('خطای ' + response.data.errorCode + ' : ' + response.data.description))
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  Edit = (numRow) => {
    let warehouseId = this.state.warehouses[numRow].id
    let warehouseName = this.state.warehouses[numRow].name
    this.setState({
      wareTypeStatus: this.state.warehouses[numRow].typePrimaryId
    })

    sessionStorage.setItem('id', warehouseId)
    sessionStorage.setItem('warehouseName', warehouseName)
    sessionStorage.setItem('typePrimary', this.state.warehouses[numRow].typePrimaryId)
    sessionStorage.setItem('personId', this.state.warehouses[numRow].personId)
    sessionStorage.setItem(
      'externalId',
      this.state.warehouses[numRow].externalId == null ? '' : this.state.warehouses[numRow].externalId
    )
    sessionStorage.setItem('sortOrder', this.state.warehouses[numRow].sortOrder)
    this.setState({
      modalEdit: !this.state.modalEdit
    })
  }
  EditCancel = () => {
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('warehouseName')
    sessionStorage.removeItem('typePrimary')
    sessionStorage.removeItem('externalId')
    sessionStorage.removeItem('sortOrder')
    this.setState({
      modalEdit: !this.state.modalEdit
    })
  }

  toggleEditCancel = () => {
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('warehouseName')
    sessionStorage.removeItem('typePrimary')
    sessionStorage.removeItem('externalId')
    sessionStorage.removeItem('sortOrder')
    this.setState({
      modalEdit: !this.state.modalEdit
    })
  }

  EditOk() {
    if (sessionStorage.getItem('typePrimary') == '5') {
      let warehouserId = sessionStorage.getItem('id')
      let name = document.getElementById('name').value
      let driverId = document.getElementById('driverId').value
      let typePrimary = document.getElementById('typePrimary').value
      let externalId = document.getElementById('externalId').value
      let sortOrder = document.getElementById('sortOrder').value

      let nameError = false
      let editError = false
      let externalError = false
      let sortOrderError = false
      let typePrimaryError = false
      let driverIdError = false

      if (driverId == '') {
        driverIdError = true
        editError = true
        message.error('برای ویرایش انبارک,مشخص کردن رساننده الزامی است')
      } else {
        if (!driverIdError) {
          this.setState({
            error: ''
          })
        }
      }

      if (name == '') {
        nameError = true
        editError = true
        message.error('لطفا نام انبار را وارد کنید')

        this.setState({
          errorname: 'نام انبار را وارد کنید'
        })
      } else {
        if (!nameError) {
          this.setState({
            errorname: ''
          })
        }
      }
      if (typePrimary == '') {
        editError = true
        typePrimaryError = true
        message.error('لطفا نوع انبار را وارد کنید')

        this.setState({
          errorType: 'نوع انبار را وارد کنید'
        })
      } else {
        if (!typePrimaryError) {
          this.setState({
            errorType: ''
          })
        }
      }
      if (externalId != '' && externalId.match(/[A-Z آ-ی a-z]/g)) {
        externalError = true
        editError = true
        message.error('شناسه خارجی باید عددی باشد')
      } else {
        if (!externalError) {
          this.setState({
            error: ''
          })
        }
      }

      if (sortOrder.match(/[A-Z آ-ی a-z]/g)) {
        sortOrderError = true
        editError = true
        message.error('ترتیب نمایش باید عددی باشد')
      } else {
        if (!sortOrderError) {
          this.setState({
            error: ''
          })
        }
      }

      if (!editError) {
        let data = {
          id: warehouserId,
          name: name,
          typePrimary: Number(typePrimary),
          externalId: externalId == '' ? undefined : Number(externalId),
          sortOrder: Number(sortOrder),
          driverId
        }

        http.post(`${WAREHOUSE.WAREHOUSE_TYPE_EDIT_WAREHOUSE}`, data, {}).then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            message.success('ویرایش انبار با موفقیت انجام شد')
            this.setState({
              modalEdit: !this.state.modalEdit
            })
            this.getAllWarehouse()
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
            this.setState({
              modalEdit: !this.state.modalEdit
            })
          }
        })
      }
    } else {
      let warehouserId = sessionStorage.getItem('id')
      let name = document.getElementById('name').value
      let typePrimary = document.getElementById('typePrimary').value
      let externalId = document.getElementById('externalId').value
      let sortOrder = document.getElementById('sortOrder').value

      let nameError = false
      let editError = false
      let externalError = false
      let sortOrderError = false
      let typePrimaryError = false
      if (name == '') {
        nameError = true
        editError = true
        message.error('لطفا نام انبار را وارد کنید')

        this.setState({
          errorname: 'نام انبار را وارد کنید'
        })
      } else {
        if (!nameError) {
          this.setState({
            errorname: ''
          })
        }
      }
      if (typePrimary == '') {
        editError = true
        typePrimaryError = true
        message.error('لطفا نوع انبار را وارد کنید')

        this.setState({
          errorType: 'نوع انبار را وارد کنید'
        })
      } else {
        if (!typePrimaryError) {
          this.setState({
            errorType: ''
          })
        }
      }
      if (externalId != '' && externalId.match(/[A-Z آ-ی a-z]/g)) {
        externalError = true
        editError = true
        message.error('شناسه خارجی باید عددی باشد')
      } else {
        if (!externalError) {
          this.setState({
            error: ''
          })
        }
      }

      if (sortOrder.match(/[A-Z آ-ی a-z]/g)) {
        sortOrderError = true
        editError = true
        message.error('ترتیب نمایش باید عددی باشد')
      } else {
        if (!sortOrderError) {
          this.setState({
            error: ''
          })
        }
      }

      if (!editError) {
        const token = sessionStorage.getItem('accessToken')
        let data = {
          id: warehouserId,
          name: name,
          typePrimary: Number(typePrimary),
          externalId: externalId == '' ? undefined : Number(externalId),
          sortOrder: Number(sortOrder)
        }

        http.post(`${WAREHOUSE.WAREHOUSE_TYPE_EDIT_WAREHOUSE}`, data, {}).then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            message.success('ویرایش انبار با موفقیت انجام شد')
            this.setState({
              modalEdit: !this.state.modalEdit
            })
            this.getAllWarehouse()
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
            this.setState({
              modalEdit: !this.state.modalEdit
            })
          }
        })
      }
    }
  }

  activate = (numRow) => {
    let status = this.state.warehouses[numRow].enabled
    if (status) {
      let id = this.state.warehouses[numRow].id
      let data = {
        id: id
      }

      http
        .post(`${WAREHOUSE.WAREHOUSE_TYPE_DISALBE_WAREHOUSE}`, data, {})
        .then((response) => {
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            this.getAllWarehouse()
          } else {
            message.error('عملیات تغییر وضعیت انبار موفق نبود')
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    } else {
      let id = this.state.warehouses[numRow].id
      let data = {
        id: id
      }

      http
        .post(`${WAREHOUSE.WAREHOUSE_TYPE_ENABLE_WAREHOUSE}`, data, {})
        .then((response) => {
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            this.getAllWarehouse()
          } else {
            message.error('عملیات تغییر وضعیت انبار موفق نبود')
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  onResultFetched(data) {
    this.setState({
      warehouses: data
    })
  }
  filter() {
    var warehousename = document.getElementById('filterwarehousename').value
    var typePrimary = document.getElementById('filtertypePrimary').value
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', `typePrimary=${typePrimary}&name=${warehousename}`)

    this.getAllWarehouse()
  }

  changeDropDown(data) {
    this.setState({
      warehouses: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  exportExcel = () => {
    http
      .get(
        `${WAREHOUSE.WAREHOUSE_REPORT_TYPE_WAREHOUSE}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            if (excelReport[i]['enabled']) {
              excelReport[i]['enabled'] = 'فعال'
            } else {
              excelReport[i]['enabled'] = 'غیر فعال'
            }
          }
          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(`${WAREHOUSE.WAREHOUSE_REPORT_TYPE_WAREHOUSE}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    const wareName = sessionStorage.getItem('warehouseName')
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let personId = sessionStorage.getItem('personId')

    let excelColumns = [
      {title: 'نام انبار', value: 'name'},
      {title: 'شناسه خارجی انبار', value: 'externalId'},
      {title: 'ترتیب نمایش', value: 'sortOrder'}
    ]
    let printCol = ['ID', 'نام انبار', 'نوع انبار', 'شناسه خارجی انبار', 'اولویت نمایش', 'وضعیت']

    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش لیست انبار ها"
              headerColSpan={6}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={4}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((warehouse, index) => (
                <tr key={'i' + index}>
                  <td>{warehouse.id}</td>
                  <td>{warehouse.name}</td>
                  <td>{warehouse.typePrimaryName}</td>
                  <td>{warehouse.externalId}</td>
                  <td>{warehouse.sortOrder}</td>
                  <td>{warehouse.enabled ? 'فعال' : 'غیر فعال'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش لیست انبار ها.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'id'}
                field={'id'}
                title={'ID'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'name'}
                field={'name'}
                title={'نام انبار'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'typePrimaryName'}
                field={'typePrimaryName'}
                title={'نوع انبار'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'externalId'}
                field={'externalId'}
                title={'شناسه خارجی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'sortOrder'}
                field={'sortOrder'}
                title={'ترتیب نمایش'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'enabled'}
                field={'enabled'}
                title={'وضعیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>انبار</li>
            <li>لیست انبار ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl="/addWarehouse"
                  printUrl=""
                  printLink=""
                  url={WAREHOUSE.WAREHOUSE_REPORT_TYPE_WAREHOUSE}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printComponent={this.printTable}
                  execelUrl={WAREHOUSE.WAREHOUSE_REPORT_TYPE_WAREHOUSE + '?export=true'}
                  excelColumns={excelColumns}
                  titleAdd="افزودن انبار"
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="filterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>نام انبار:</label>
                  <select className="form-control" id="filterwarehousename">
                    <option value="">-----</option>
                    {this.state.wareHousesname.map((items, index) => (
                      <option key={index} value={items.name}>
                        {items.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="formComponent">
                  <label>نوع انبار : </label>
                  <select className="form-control" id="filtertypePrimary" name="typePrimary">
                    <option value="">---------</option>
                    {this.state.wareType.map((wareType, index) => (
                      <option key={index} value={wareType.id}>
                        {wareType.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="showBaseTable tableVisibile">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ID</td>
                    <td>نام انبار</td>
                    <td>نوع انبار</td>
                    <td>شناسه خارجی انبار</td>
                    <td>ترتیب نمایش</td>
                    <td>فعال</td>
                    <td>ویرایش</td>
                    <td>حذف</td>
                  </tr>
                  {this.state.warehouses.map((warehouse, index) => (
                    <tr key={index}>
                      <td>{warehouse.id}</td>
                      <td>{warehouse.name}</td>
                      <td>{warehouse.typePrimaryName}</td>
                      <td>{warehouse.externalId}</td>
                      <td>{warehouse.sortOrder}</td>
                      <td>
                        <button onClick={() => this.activate(index)}>
                          {warehouse.enabled ? (
                            <img src={require('../../image/on.svg')} alt="" />
                          ) : (
                            <img src={require('../../image/off.svg')} alt="" />
                          )}
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.Edit(index)}>
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.delete(index)}>
                          <img src={require('../../image/trash.svg')} alt="" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.length}
                  onResultFetched={this.onResultFetched.bind(this)}
                  urlParams={sessionStorage.getItem('params')}
                  url={WAREHOUSE.WAREHOUSE_REPORT_TYPE_WAREHOUSE}
                />
              </div>
            </div>
          </div>
          <Modal isOpen={this.state.modalDelete} toggle={this.toggleCancel} size="sm">
            <ModalHeader toggle={this.toggleCancel}>حذف انبار</ModalHeader>
            <ModalBody>
              <p className="titleSm">آیا از حذف انبار {wareName} مطمئن هستید؟؟؟</p>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.deleteOk}>
                حذف انبار
              </button>
              <button className="cancelBtnModal" onClick={this.deleteCancel}>
                لغو
              </button>
            </ModalFooter>
          </Modal>

          <Modal isOpen={this.state.modalEdit} toggle={this.toggleEditCancel}>
            <ModalHeader toggle={this.toggleEditCancel}>ویرایش انبار</ModalHeader>
            <ModalBody>
              <form className="modalForm editWareForm">
                <figure>
                  <label>نام انبار : </label>
                  <input
                    className="form-control"
                    type="text"
                    id="name"
                    name="name"
                    defaultValue={sessionStorage.getItem('warehouseName')}
                    ref={(node) => (this.input = node)}
                    onClick={() => this.input.select()}
                  />
                </figure>
                <figure>
                  <label>نوع انبار : </label>
                  <select
                    className="form-control"
                    onChange={this.changeWareType.bind(this)}
                    id="typePrimary"
                    name="typePrimary"
                  >
                    {this.state.wareType.map((wareType, index) => (
                      <option
                        key={index}
                        value={wareType.id}
                        selected={wareType.id == sessionStorage.getItem('typePrimary') ? true : false}
                      >
                        {wareType.name}
                      </option>
                    ))}
                  </select>
                </figure>
                <figure>
                  <label>شناسه خارجی انبار : </label>
                  <input
                    className="form-control"
                    type="text"
                    id="externalId"
                    min="1"
                    name="externalId"
                    defaultValue={sessionStorage.getItem('externalId')}
                  />
                </figure>

                <figure>
                  <label>ترتیب نمایش : </label>
                  <input
                    className="form-control"
                    type="number"
                    id="sortOrder"
                    min="1"
                    name="sortOrder"
                    defaultValue={sessionStorage.getItem('sortOrder')}
                  />
                </figure>
                <figure style={sessionStorage.getItem('typePrimary') == '5' ? {display: 'block'} : {display: 'none'}}>
                  <label>رساننده </label>
                  <select className="form-control" id="driverId" name="driverId">
                    <option value="">---------</option>
                    {this.state.Drivers.map((driver, index) => (
                      <option
                        key={`driver${index}`}
                        selected={personId == driver.personId ? true : false}
                        value={driver.personId}
                      >
                        {driver.name}
                      </option>
                    ))}
                  </select>
                </figure>

                <figure>
                  <label className="hiddenLabel">ds </label>
                </figure>
              </form>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.EditOk.bind(this)}>
                ویرایش انبار
              </button>
              <button className="cancelBtnModal" onClick={this.EditCancel}>
                لغو
              </button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

export default WareHouseList
